import {OnInit} from '@angular/core';
import {CrudListComponent} from "../_directives";
import {Observable} from "rxjs";
import {BasePlan} from "../_models";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {AlertService, CrudService} from "../_services";
import {takeUntil} from "rxjs/operators";

export abstract class PlanListAbstractComponent extends CrudListComponent implements OnInit {
  plans$: Observable<BasePlan[]> = this.data$;
  routePrefix = 'plan';
  planLabel = 'Billing Plan';

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected planService: CrudService,
    protected alertService: AlertService,
  ) {
    super(router, location, route, planService, alertService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  isEnabled(plan: BasePlan) {
    return plan.is_active;
  }

  enable(plan: BasePlan, event) {
    let enable: boolean = event.target.checked;
    let action = enable ? 'enable' : 'disable';

    if (window.confirm('Are you sure you want to ' + action + ' ' + plan.name + ' plan?')) {
      this.planService.patch(plan.id, {is_active: enable})
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          data => {
            action = enable ? 'Enabled' : 'Disabled';
            this.alertService.success(action + ' ' + plan.name + ' plan.');
          },
          error => {
            this.handleSubmitError(error);
            event.target.checked = !enable;
          });
    } else {
      event.target.checked = !enable;
    }
  }

}
